import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const settingsCallManagement = createApi({
    reducerPath: "settingsCallManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        appointmentList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/calls-appointment`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewAppointment: builder.mutation({
            query: (appointmentId) => ({
                url: `v1/${locale}/settings/calls-appointment/${appointmentId}`,
                method: "GET",
            }),
        }),
        addAppointment: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/calls-appointment`,
                method: "POST",
                body: body,
            }),
        }),
        updateAppointment: builder.mutation({
            query: ({ body, appointmentId }) => ({
                url: `v1/${locale}/settings/calls-appointment/${appointmentId}`,
                method: "PATCH",
                body: body,
            }),
        }),
        deleteAppointment: builder.mutation({
            query: (appointmentId) => ({
                url: `v1/${locale}/settings/calls-appointment/${appointmentId}`,
                method: "DELETE",
            }),
        }),

        courseTypeList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/calls-course-type`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewCourseType: builder.mutation({
            query: (courseTypeId) => ({
                url: `v1/${locale}/settings/calls-course-type/${courseTypeId}`,
                method: "GET",
            }),
        }),
        addCourseType: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/calls-course-type`,
                method: "POST",
                body: body,
            }),
        }),
        updateCourseType: builder.mutation({
            query: ({ body, courseTypeId }) => ({
                url: `v1/${locale}/settings/calls-course-type/${courseTypeId}`,
                method: "PATCH",
                body: body,
            }),
        }),
        deleteCourseType: builder.mutation({
            query: (courseTypeId) => ({
                url: `v1/${locale}/settings/calls-course-type/${courseTypeId}`,
                method: "DELETE",
            }),
        }),

        methodOfContactList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/calls-method-of-contact`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewMethodOfContact: builder.mutation({
            query: (methodOfContactId) => ({
                url: `v1/${locale}/settings/calls-method-of-contact/${methodOfContactId}`,
                method: "GET",
            }),
        }),
        addMethodOfContact: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/calls-method-of-contact`,
                method: "POST",
                body: body,
            }),
        }),
        updateMethodOfContact: builder.mutation({
            query: ({ body, methodOfContactId }) => ({
                url: `v1/${locale}/settings/calls-method-of-contact/${methodOfContactId}`,
                method: "PATCH",
                body: body,
            }),
        }),
        deleteMethodOfContact: builder.mutation({
            query: (methodOfContactId) => ({
                url: `v1/${locale}/settings/calls-method-of-contact/${methodOfContactId}`,
                method: "DELETE",
            }),
        }),

        salesChannelList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/calls-sales-channel`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewSalesChannel: builder.mutation({
            query: (salesChannelId) => ({
                url: `v1/${locale}/settings/calls-sales-channel/${salesChannelId}`,
                method: "GET",
            }),
        }),
        addSalesChannel: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/calls-sales-channel`,
                method: "POST",
                body: body,
            }),
        }),
        updateSalesChannel: builder.mutation({
            query: ({ body, salesChannelId }) => ({
                url: `v1/${locale}/settings/calls-sales-channel/${salesChannelId}`,
                method: "PATCH",
                body: body,
            }),
        }),
        deleteSalesChannel: builder.mutation({
            query: (salesChannelId) => ({
                url: `v1/${locale}/settings/calls-sales-channel/${salesChannelId}`,
                method: "DELETE",
            }),
        }),

        studentStatusList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/calls-student-status`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewStudentStatus: builder.mutation({
            query: (studentStatusId) => ({
                url: `v1/${locale}/settings/calls-student-status/${studentStatusId}`,
                method: "GET",
            }),
        }),
        addStudentStatus: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/calls-student-status`,
                method: "POST",
                body: body,
            }),
        }),
        updateStudentStatus: builder.mutation({
            query: ({ body, studentStatusId }) => ({
                url: `v1/${locale}/settings/calls-student-status/${studentStatusId}`,
                method: "PATCH",
                body: body,
            }),
        }),
        deleteStudentStatus: builder.mutation({
            query: (studentStatusId) => ({
                url: `v1/${locale}/settings/calls-student-status/${studentStatusId}`,
                method: "DELETE",
            }),
        }),

        statusList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/calls-status`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewStatus: builder.mutation({
            query: (statusId) => ({
                url: `v1/${locale}/settings/calls-status/${statusId}`,
                method: "GET",
            }),
        }),
        addStatus: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/calls-status`,
                method: "POST",
                body: body,
            }),
        }),
        updateStatus: builder.mutation({
            query: ({ body, statusId }) => ({
                url: `v1/${locale}/settings/calls-status/${statusId}`,
                method: "PATCH",
                body: body,
            }),
        }),
        deleteStatus: builder.mutation({
            query: (statusId) => ({
                url: `v1/${locale}/settings/calls-status/${statusId}`,
                method: "DELETE",
            }),
        }),

        offerSentList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/calls-offer-sent`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewOfferSent: builder.mutation({
            query: (offerSentId) => ({
                url: `v1/${locale}/settings/calls-offer-sent/${offerSentId}`,
                method: "GET",
            }),
        }),
        addOfferSent: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/calls-offer-sent`,
                method: "POST",
                body: body,
            }),
        }),
        updateOfferSent: builder.mutation({
            query: ({ body, offerSentId }) => ({
                url: `v1/${locale}/settings/calls-offer-sent/${offerSentId}`,
                method: "PATCH",
                body: body,
            }),
        }),
        deleteOfferSent: builder.mutation({
            query: (offerSentId) => ({
                url: `v1/${locale}/settings/calls-offer-sent/${offerSentId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const { 
    useAppointmentListMutation,
    useAddAppointmentMutation,
    useDeleteAppointmentMutation,
    useUpdateAppointmentMutation,
    useViewAppointmentMutation,

    useCourseTypeListMutation,
    useAddCourseTypeMutation,
    useDeleteCourseTypeMutation,
    useUpdateCourseTypeMutation,
    useViewCourseTypeMutation,

    useAddMethodOfContactMutation,
    useDeleteMethodOfContactMutation,
    useMethodOfContactListMutation,
    useUpdateMethodOfContactMutation,
    useViewMethodOfContactMutation,

    useAddSalesChannelMutation,
    useDeleteSalesChannelMutation,
    useSalesChannelListMutation,
    useUpdateSalesChannelMutation,
    useViewSalesChannelMutation,

    useAddStudentStatusMutation,
    useDeleteStudentStatusMutation,
    useStudentStatusListMutation,
    useUpdateStudentStatusMutation,
    useViewStudentStatusMutation,

    useAddStatusMutation,
    useDeleteStatusMutation,
    useStatusListMutation,
    useUpdateStatusMutation,
    useViewStatusMutation,

    useAddOfferSentMutation,
    useDeleteOfferSentMutation,
    useOfferSentListMutation,
    useUpdateOfferSentMutation,
    useViewOfferSentMutation
} = settingsCallManagement;
